import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { SEO } from '../components/SEO';
import { Card } from '../components/ui/card';
import { ContactForm } from '../components/ContactForm';
import { Mail, Globe, MapPin } from 'lucide-react';

export const ContactPage = () => {
  const { t, language } = useLanguage();

  return (
    <>
      <SEO 
        title={t('pages.contact.title')}
        description={t('pages.contact.intro')}
        path="/contacto"
      />

      <div className="pt-32 pb-24 bg-gradient-to-b from-white to-slate-50 min-h-screen">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-4xl mx-auto">
            {/* Header */}
            <div className="text-center mb-16 space-y-4">
              <h1 className="text-5xl md:text-6xl font-bold gradient-text" data-testid="contact-page-title">
                {t('pages.contact.title')}
              </h1>
              <p className="text-xl text-slate-600 max-w-2xl mx-auto" data-testid="contact-page-intro">
                {language === 'es'
                  ? 'Conectemos para hablar sobre oportunidades de inversión, offtake y alianzas estratégicas.'
                  : "Let's connect to discuss investment opportunities, offtake and strategic partnerships."}
              </p>
            </div>

            {/* Contact Info Cards */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-12">
              <Card className="p-6 text-center border-0 bg-white hover:shadow-lg transition-shadow">
                <Mail className="w-8 h-8 text-primary-500 mx-auto mb-3" />
                <div className="text-sm font-medium text-slate-600">Email</div>
                <div className="text-sm text-slate-900">info@paraguanah2.com</div>
              </Card>

              <Card className="p-6 text-center border-0 bg-white hover:shadow-lg transition-shadow">
                <Globe className="w-8 h-8 text-primary-500 mx-auto mb-3" />
                <div className="text-sm font-medium text-slate-600">Web</div>
                <div className="text-sm text-slate-900">paraguanah2.com</div>
              </Card>

              <Card className="p-6 text-center border-0 bg-white hover:shadow-lg transition-shadow">
                <MapPin className="w-8 h-8 text-primary-500 mx-auto mb-3" />
                <div className="text-sm font-medium text-slate-600">{language === 'es' ? 'Ubicación' : 'Location'}</div>
                <div className="text-sm text-slate-900">Paraguaná, Venezuela</div>
              </Card>
            </div>

            {/* Form */}
            <Card className="p-8 md:p-12 bg-white shadow-xl border-0">
              <div className="mb-8 text-center">
                <h2 className="text-2xl font-bold text-slate-900 mb-2">
                  {language === 'es' ? 'Envianos un mensaje' : 'Send us a message'}
                </h2>
                <p className="text-slate-600">
                  {language === 'es'
                    ? 'Completa el formulario y nos pondremos en contacto pronto.'
                    : "Fill out the form and we'll get back to you soon."}
                </p>
              </div>
              <ContactForm source="contact-page" />
            </Card>
          </div>
        </div>
      </div>
    </>
  );
};